import { logout } from "@/api/client";
import { platform } from "@/platform";
import { useAuthStore } from "@/stores/authStore";
import { useUiStore } from "@/stores/uiStore";

export const ONBOARDING_ROUTES = ["/terms", "/birth-date", "/profile/new"] as const;

type Flags = { consentsRequired: boolean; birthDateRequired: boolean; profileRequired: boolean } | null | undefined;

/** 온보딩 남은 단계(consents → birthDate → profile). 다 마쳤으면 null */
export const onboardingStep = (user: Flags) =>
  user?.consentsRequired ? "/terms" : user?.birthDateRequired ? "/birth-date" : user?.profileRequired ? "/profile/new" : null;

/** 온보딩 미완 세션인가. 서버는 첫 프로필 생성 전까지 pending(회원 아님, account-deletion 결정 10) */
export const isOnboardingIncomplete = () => {
  const s = useAuthStore.getState();
  return s.status === "member" && onboardingStep(s.user) !== null;
};

/**
 * 온보딩 이탈 = 로그아웃(AC0-149). 부팅 시 미완 세션이 남아 있거나 온보딩 라우트 밖으로 나가면 세션을 끊고 비회원으로 되돌린다.
 * 다시 로그인하면 서버 플래그로 남은 단계부터 이어진다. 끊었으면 true.
 */
export async function abandonOnboarding(): Promise<boolean> {
  if (!isOnboardingIncomplete()) return false;
  await logout();
  await platform.auth.signOut().catch(() => undefined);
  useUiStore.getState().setReturnTo(null);
  return true;
}
